// extracted by mini-css-extract-plugin
module.exports = {"datasetsContainer":"AlgorithmDatasetsListForCompute-module--datasetsContainer--2XzTU","text":"AlgorithmDatasetsListForCompute-module--text--3MW_N"};